import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

function StrappingAndPackaging({
  onClose,
  valorActualExpo,
  actualizarTarifa,
  concepto,
}) {
  const [skid, setSkid] = useState("");
  const [pieza, setPieza] = useState("");
  const [medio, setMedio] = useState("");
  const [std, setStd] = useState("");

  // 🔹 Cargar datos simulados del back
  useEffect(() => {
    if (valorActualExpo) {
      setSkid(valorActualExpo.skid || "");
      setPieza(valorActualExpo.pieza || "");
      setMedio(valorActualExpo.medio || "");
      setStd(valorActualExpo.std || "");
    }
  }, [valorActualExpo]);

  const handleActualizar = () => {
    actualizarTarifa(concepto, {
      skid,
      pieza,
      medio: medio,
      std,
    });

    Swal.fire({
      title: "Éxito",
      text: "Datos actualizados correctamente",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-6">
                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Fleje skid 1.60m (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={skid}
                    onChange={(e) => setSkid(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Fleje pieza suelta (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={pieza}
                    onChange={(e) => setPieza(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Vitafilm skid medio (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={medio}
                    onChange={(e) => setMedio(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Suministro de Tarima Std (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={std}
                    onChange={(e) => setStd(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-6">
              <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Fleje skid 1.60m (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={skid}
                    onChange={(e) => setSkid(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Fleje pieza suelta (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={pieza}
                    onChange={(e) => setPieza(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Vitafilm skid medio (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={medio}
                    onChange={(e) => setMedio(e.target.value)}
                  />
                </div>

                <div className="row mb-4">
                  <label className="fw-bold d-block mb-2">
                    Suministro de Tarima Std (MXN)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={std}
                    onChange={(e) => setStd(e.target.value)}
                  />
                </div>
                
                <div className="d-flex justify-content-end">
                  <button className="btnn" onClick={handleActualizar}>
                    Actualizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StrappingAndPackaging;
